import OwnImage from "@ui/components/ui/event/OwnImage";
import { useUserContext } from "@web-app/src/context/auth/user.context";
import Link from "next/link";
import AddEvent from "../Event/AddEvent";
import SocialMedia from "./SocialMedia";

const FooterDesktop = () => {
  const { user } = useUserContext();

  return (
    <div className="h-full bg-white px-20 pb-12 pt-16 md:block">
      <div>
        <div className="flex h-[32px] flex-row justify-between">
          <div className="flex flex-row items-center justify-between">
            <OwnImage
              src="/images/logos/logo_connect_events_horizontale.png"
              alt="logo avec nom Connect'Events"
              className="static h-9 w-auto p-1"
              width={880}
              height={200}
            />
          </div>
          <Link href="https://www.bourgognefranchecomte.fr" target="_blank">
            <div className="relative aspect-[14.5/11.6] h-[20mm] min-h-[11.6mm] min-w-[14.5mm]">
              <OwnImage
                src="/images/logos/region_bfc.jpg"
                alt="logo"
                className="size-full object-cover"
              />
            </div>
          </Link>
        </div>
        <div className="flex items-center gap-8 pt-8 text-base font-semibold text-primary-600">
          <Link href={"/"}>Découvrir</Link>
          <AddEvent className="text-base" />
          <Link href={"/profile/faq"}>FAQ</Link>
          <Link href={"/profile/help"}>Aide</Link>
        </div>
      </div>
      <div className="flex flex-col justify-between pt-4">
        <p className="pb-2 text-base font-semibold text-gray-700">
          Rejoignez-nous sur
        </p>
        <div className="flex flex-row gap-4">
          <SocialMedia
            svgName="instagram_logo"
            url="https://www.instagram.com/connect_events_off"
          />
          <SocialMedia
            svgName="facebook_logo"
            url="https://www.facebook.com/people/ConnectEvents/61576724692750"
          />
          <SocialMedia
            svgName="linkedin_logo"
            url="https://www.linkedin.com/company/acexpo-connectevents/posts/?feedView=all"
          />
        </div>
      </div>
      <div className="flex items-center justify-between pt-8 text-xs text-gray-700">
        <p className="text-gray-500">© Connect&apos;Events</p>
        <div className="flex gap-4">
          <Link href="/cgu" target="_blank">
            CGU
          </Link>
          <Link href="/cgv" target="_blank">
            CGV
          </Link>
          <Link href="/politique-de-confidentialite" target="_blank">
            Politique de confidentialité
          </Link>
          {user && user.isProfessional ? (
            <>
              <Link
                href="https://professionnels.connect-events.fr/conditions-d-acces-pro"
                target="_blank"
              >
                Conditions d&apos;accès pro
              </Link>
              <Link
                href="https://professionnels.connect-events.fr/politique-de-confidentialite"
                target="_blank"
              >
                Mentions légales
              </Link>
            </>
          ) : (
            <Link href="/mentions-legales" target="_blank">
              Mentions légales
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default FooterDesktop;
